import { createContext, useContext } from 'react'
import { type DataExplorerParamsState } from 'domains/insights-portal/components/data-explorer/utils/filter-params/dataExplorerParams.types'

export const DataExplorerParamsContext = createContext<DataExplorerParamsState>(undefined)
export const useDataExplorerParamsContext = () => useContext(DataExplorerParamsContext)
